import * as angular from "angular";
import {IController} from "angular";

export class PlanningResourceActionButtonCtrl implements IController {
  resource: any;
  onCreateARoute: Function;
  onAddToDraft: Function;
  onRemoveFromDraft: Function;


  /* @ngInject */
  constructor() {
  }

  onOpen($mdMenu, ev) {
    $mdMenu.open(ev);
  }

  closeActionsMenu($mdMenu, ev) {
    $mdMenu.close();
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningResourceActionButton', {
    bindings: {
      resource: '<',
      onCreateARoute: '&',
      onAddToDraft: '&',
      onRemoveFromDraft: '&'
    },
    template: require('./planning-resource-action-button.html').default,
    controller: PlanningResourceActionButtonCtrl
  });
